<template>
  <div>
    <div
      class="menu-title"
      :class="{'wait-submit-bg':taskItem.themeStatus === 0,'effect-bg':taskItem.themeStatus === 200,'disable-bg':taskItem.publishStatus === 0,'overdue-bg':taskItem.themeStatus === 900}"
    >
      <span class="themeName" :title="taskItem.themeName">{{taskItem.themeName}}</span>
      <span style="font-size:16px">{{taskItem.channelName}}</span>
    </div>
    <div class="menu-configuration" @click="goView(taskItem)">
      <div
        class="menu-task"
        :class="{'wait-submit-border':taskItem.themeStatus === 0 || taskItem.alreadyConfiguredQty !== 1,'effect-border':taskItem.themeStatus === 200 && taskItem.alreadyConfiguredQty === 1,'disable-border':taskItem.publishStatus === 0,'overdue-border':taskItem.themeStatus === 900}"
      >
        <div v-if="taskItem.taskTypeNameScope.length">{{taskItem.taskTypeNameScope.replace(/,/g , '+')}}</div>
        <div v-else style="color:#2081e6">完善任务配置</div>
        <!-- <span :class="taskItem.publishStatus === 0?'red':'green'" class="menu-status">{{taskItem.publishStatus === 0?'已禁用':taskItem.themeStatusName}}</span> -->
      </div>
      <div class="menu-data">{{taskItem.startDate | parseTime("{y}-{m}-{d}")}}至 {{taskItem.endDate | parseTime("{y}-{m}-{d}")}}</div>
    </div>
    <div
      class="menu-status"
      :class="{'wait-submit-bg':taskItem.themeStatus === 0,'effect-bg':taskItem.themeStatus === 200,'disable-bg':taskItem.publishStatus === 0,'overdue-bg':taskItem.themeStatus === 900,
              'wait-submit-text':taskItem.themeStatus === 0,'effect-text':taskItem.themeStatus === 200,'disable-text':taskItem.publishStatus === 0,'overdue-text':taskItem.themeStatus === 900
            }"
    >{{taskItem.publishStatus === 0?'已禁用':taskItem.themeStatusName}}</div>
  </div>
</template>

<script>
export default {
  props: {
    taskItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    orgCode: {
      type: String,
      default: ''
    },
    history: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goView (themeDefine) {
      if (this.history) {
        this.$router.push({ name: 'perfect/history-hq', query: { themeDefineId: themeDefine.themeDefineId } })
      } else {
        if (themeDefine.themeStatus === 0) {
        // 待提交状态活动直接进编辑页面
          this.$router.push({
            name: 'trade-perfect-hq-config',
            query: {
              themeDefineId: themeDefine.themeDefineId,
              type: '01',
              status: themeDefine.themeStatus
            }
          })
        } else {
          this.$router.push({ name: 'trade-perfect-hq-detail', query: { themeDefineId: themeDefine.themeDefineId } })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-title {
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #bbb;
  height: 35px;
  box-sizing: border-box;
}
.themeName {
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
}
.menu-goConfiguration {
  // padding-top: 25px;
  margin-top: 10px;
  height: 95px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 20px;
    color: #bbbbbb;
  }
  p {
    color: #59a6ff;
  }
}
.menu-configuration {
  cursor: pointer;
  height: 77px;
  text-align: left;

  .menu-task {
    text-align: center;
    font-size: 16px;
    line-height: 77px;
    // border-bottom: 1px solid #ddd;
    .green {
      color: #64d795;
      border: 1px solid #64d795;
    }
    .red {
      color: #cd1231;
      border: 1px solid #cd1231;
    }
  }
  .menu-data {
    line-height: 34px;
    padding: 0 10px;
    color: #666;
  }
}
.menu-status {
  position: absolute;
  right: 0;
  bottom: 0px;
  padding: 4px 13px 4px 15px;
  border-top-left-radius: 16px;
  // border-bottom-left-radius: 15px;
}
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}

.wait-submit-bg {
  background-color: #d0eef9;
}
.wait-submit-text {
  color: #1dace4;
}
.wait-submit-border {
  border-bottom: 1px solid #d0eef9;
}
.effect-bg {
  background-color: #daeee2;
}
.effect-border {
  border-bottom: 1px solid #daeee2;
}
.effect-text {
  color: #95ceab;
}
.disable-bg {
  background-color: #fbd7cb;
}
.disable-border {
  border-bottom: 1px solid #fbd7cb;
}
.disable-text {
  color: #e95429;
}
.overdue-bg {
  background-color: #e9e9e9;
}
.overdue-border {
  border-bottom: 1px solid #e9e9e9;
}
.overdue-text {
  color: #ccc;
}
</style>
